import { render } from "./ForgotPassword.vue?vue&type=template&id=5f1f1805"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f1f1805"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f1f1805', __exports__)) {
    api.reload('5f1f1805', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=5f1f1805", () => {
    api.rerender('5f1f1805', render)
  })

}


export default __exports__